import { jwtDecode } from 'jwt-decode';

import { getAuthToken } from 'Api/utils/getAuthHeaders';
import { authTypes, logout } from 'utils/Auth';
import { store } from '@redux/store';
import { requestRefreshTokenLocalAuth } from './localAuth';
import { requestRefreshTokenSSO } from './SSOAuth';

export const isTokenExpired = () => {
  const token = getAuthToken();
  if (token) {
    const decoded = jwtDecode(token);
    return decoded.exp < Date.now() / 1000;
  } else {
    return true;
  }
};

export const getExpiryAndDecodedToken = () => {
  const token = getAuthToken();

  if (!token) {
    return null;
  }
  try {
    const decoded = jwtDecode(token);
    const expMs = decoded.exp * 1000;
    const currentTimeMs = Date.now();

    // Calculate the time until we should refresh the token
    // if it is already less than 5 mins, return 0
    const timeUntilExpiryMs = expMs - currentTimeMs;
    const refreshWindowMs = 5 * 60 * 1000; // 5 minutes in milliseconds
    const timeUntilRefreshMs = Math.max(0, timeUntilExpiryMs - refreshWindowMs);
    return {
      expTime: decoded.exp,
      decodedToken: decoded,
      targetRefreshMs: timeUntilRefreshMs,
    };
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const refreshAuthToken = async () => {
  const expDateObj = getExpiryAndDecodedToken();

  if (!expDateObj) {
    logout();
    return;
  }
  const { decodedToken } = expDateObj;
  const state = store.getState();

  // if SSO authType, request refresh tokens, else redirect to login
  if (state.userInfo.authType === authTypes.eoauth) {
    await requestRefreshTokenSSO(decodedToken);
  } else if (state.userInfo.authType === authTypes.db) {
    await requestRefreshTokenLocalAuth();
  } else {
    logout();
  }
};
